import { Link } from "react-router-dom";
import { Brand } from "@/components/hm/Basics";

export const SiteFooter = ({ inApp = false }) => (
  <footer className="site-footer" data-testid="app-footer" style={inApp ? { marginTop: "3rem" } : undefined}>
    <div className="wrap">
      <div className="foot">
        <div>
          <Brand />
          <p className="text-muted" style={{ margin: "1rem 0 0", maxWidth: "36ch", fontSize: 14.5 }}>
            Módulos breves, ejercicios y una comunidad tranquila para entender lo que sientes.
          </p>
          <div className="help-note foot-help" data-testid="footer-help-note">
            Heartmony no sustituye a un profesional. Si lo que sientes te supera, llama al 024. Es gratis y confidencial. Si es una urgencia, llama al 112.
          </div>
        </div>
        <div>
          <h5>Espacios</h5>
          <ul>
            <li><Link to="/academia">Academia</Link></li>
            <li><Link to="/recursos">Recursos</Link></li>
            <li><Link to="/comunidad">Comunidad</Link></li>
            <li><Link to="/planes">Planes</Link></li>
          </ul>
        </div>
        <div>
          <h5>Ayuda</h5>
          <ul>
            <li><a href="/#faq">Preguntas</a></li>
            <li><a href="mailto:contacto@heartmony.es" data-testid="footer-contact-link">contacto@heartmony.es</a></li>
          </ul>
        </div>
        <div>
          <h5>Legal</h5>
          <ul>
            <li><Link to="/privacidad" data-testid="footer-privacy-link">Aviso de privacidad</Link></li>
          </ul>
        </div>
      </div>
      <div className="foot-b">
        <span>Heartmony · claridad para tu despertar</span>
        <span>© 2026 Heartmony</span>
      </div>
    </div>
  </footer>
);
